// Predefined Non-Google Technologies
export const NON_GOOGLE_TECHNOLOGIES = [
  "React",
  "Vue.js",
  "Node.js",
  "Python",
  "JavaScript",
  "TypeScript",
  "Java",
  "C++",
  "Docker",
  "Kubernetes",
  "AWS",
  "Azure",
  "MongoDB",
  "PostgreSQL",
  "MySQL",
  "Redis",
  "GraphQL",
  "REST API",
  "WebSocket",
  "Git",
  "GitHub",
  "GitLab",
  "CI/CD",
  "Linux",
  "Nginx",
  "Apache",
];

